import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from '@mui/material';
import React, { Component } from 'react';

interface Props {
    deleting: boolean;
    name?: string;
    onCancel: () => void;
    onConfirm: () => void;
    totalDays?: number;
    totalWeeks?: number;
    visible: boolean;
}

interface State {
    acknowledged: boolean;
}

class DeleteProgramDialog extends Component<Props, State> {
    state: State = {
        acknowledged: false,
    };

    componentDidUpdate(prevProps: Props) {
        if (!prevProps.visible && this.props.visible) {
            this.setState({ acknowledged: false });
        }
    }

    onAcknowledgedChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ acknowledged: event.target.checked });
    };

    render() {
        const { deleting, name, onCancel, onConfirm, totalDays, totalWeeks, visible } = this.props;

        return (
            <Dialog fullWidth maxWidth="xs" open={visible}>
                <DialogTitle>Delete Program</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: 'grid', gap: 1.25 }}>
                        <Typography variant="body2"><strong>Program:</strong> {name}</Typography>
                        <Typography variant="body2"><strong>Weeks:</strong> {totalWeeks || 0}</Typography>
                        <Typography variant="body2"><strong>Configured day entries:</strong> {totalDays || 0}</Typography>
                        <Typography color="text.secondary" variant="body2">
                            This action permanently deletes the full program and cannot be undone.
                        </Typography>
                        <FormControlLabel
                            control={<Checkbox checked={this.state.acknowledged} onChange={this.onAcknowledgedChanged} />}
                            label="I understand this cannot be undone"
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button disabled={deleting} onClick={onCancel}>Cancel</Button>
                    <Button color="error" disabled={deleting || !this.state.acknowledged} onClick={onConfirm} variant="contained">Permanently Delete</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default DeleteProgramDialog;